import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { DigitalWaiverService } from '../../../services/digital-waiver.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatDialogRef } from '@angular/material/dialog';
import { PasteCleanupSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarSettingsModel } from '@syncfusion/ej2-angular-dropdowns';

@Component({
  selector: 'waiver-create-modal',
  templateUrl: './waiver-create-modal.component.html',
  styleUrl: './waiver-create-modal.component.scss',
  standalone: false
})
export class WaiverCreateModalComponent extends BaseModalComponent implements OnInit {

  public form = new FormGroup({
    title: new FormControl('', [Validators.required]),
    legalTerms: new FormControl('', [Validators.required]),
    isActive: new FormControl(true)
  });

  public toolbarItems: ToolbarSettingsModel = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };

  public pasteCleanupSettings: PasteCleanupSettingsModel = {
    prompt: true,
    plainText: false,
    keepFormat: true,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
};

  constructor(
    private digitalWaiverService: DigitalWaiverService,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<WaiverCreateModalComponent>
  ) {
    super();
  }

  ngOnInit(): void {
  }

  submit() {
    if (this.form.valid) {
      this.isLoading = true;
      const data = {
        ...this.form.value,
        organizationId: this.sessionService.getUser().organizationId,
        createdBy: this.sessionService.getUserId(),
        lastEditedBy: this.sessionService.getUserId()
      };

      this.digitalWaiverService.createWaiver(data).subscribe({
        next: () => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          this.setError(error, this.form);
          this.isLoading = false;
        }
      });
    }
  }
} 